module.exports = __webpack_public_path__ + "img/noData.02049c27.png";